import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrap = _resolveComponent("message-wrap")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.message.text)
      ? (_openBlock(), _createBlock(_component_message_wrap, {
          key: 0,
          isShowMessageTail: _ctx.isShowMessageTail,
          message: _ctx.message,
          avatar: _ctx.avatar,
          class: "q-mb-sm",
          onInit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('init')))
        }, {
          default: _withCtx(() => [
            _createVNode("span", {
              textContent: _toDisplayString(_ctx.message.text)
            }, null, 8, ["textContent"])
          ]),
          _: 1
        }, 8, ["isShowMessageTail", "message", "avatar"]))
      : _createCommentVNode("", true),
    (_ctx.isLastMessage)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.questionType), {
          key: 1,
          buttons: _ctx.message.buttons,
          message: _ctx.message,
          respondentId: _ctx.respondentId,
          onClickButtonWithPayload: _cache[2] || (_cache[2] = payload => _ctx.$emit('send-message', payload)),
          onInit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('init')))
        }, null, 8, ["buttons", "message", "respondentId"]))
      : _createCommentVNode("", true)
  ]))
}